import {useQuery} from "@apollo/client";

import {useTable} from "@/lib/hooks/useTable.ts";
import {GQL_MAINTENANCE_AUDIT_EVENTS_QUERY, MaintenanceAuditEventsPageResult} from "@/lib/queries/maintenance.ts";
import {EventLogControlBar} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/EventLogTable/components/EventLogControlBar.tsx";
import {MaintenanceStatusFilters} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/EventLogTable/components/EventLogFilters.tsx";
import {EventLogTable} from "@/pages/maintenance/maintenance-dashboard/tabs/schedule-eventlog/EventLogTable/EventLogTable.tsx";

const SESSION_STORAGE_FILTERS_KEY = "maintenance_event_log_filters";

const DEFAULT_EVENT_TYPE_FILTER = MaintenanceStatusFilters.map((filter) => filter.key);

export const MaintenanceEventLogTab = () => {
  const {
    search,
    searchDebounced,
    searchChanged,
    pagination,
    setPagination,
    sorting,
    setSorting,
    sortingString,
    filterSets,
    setFilterSets,
  } = useTable({
    sessionStorageKey: SESSION_STORAGE_FILTERS_KEY,
    resetPaginationOnFilter: true,
    defaultSort: "-created_at",
    filtersKey: SESSION_STORAGE_FILTERS_KEY,
  });

  const appliedFilters = "types" in filterSets ? filterSets : {...filterSets, types: DEFAULT_EVENT_TYPE_FILTER};

  const {data, previousData, loading} = useQuery<MaintenanceAuditEventsPageResult>(GQL_MAINTENANCE_AUDIT_EVENTS_QUERY, {
    variables: {
      offset: pagination.offset,
      limit: pagination.limit,
      sort: sortingString,
      search: searchDebounced,
      filters: appliedFilters,
    },
  });

  const responseData = data?.maintenanceAuditEvents || previousData?.maintenanceAuditEvents;

  const renderData = responseData ? {items: responseData.items, total: responseData.total} : {items: [], total: 0};

  return (
    <>
      <EventLogControlBar
        search={search}
        setSearch={searchChanged}
        filterSets={filterSets}
        onFilterSetChange={setFilterSets}
      />
      <EventLogTable
        data={renderData}
        sortColumn={sorting.column}
        sortDirection={sorting.direction}
        onSortingChange={setSorting}
        pagination={pagination}
        setPagination={setPagination}
        isFiltered={!!searchDebounced || Object.keys(filterSets).length > 0}
        loading={loading}
      />
    </>
  );
};
